import { ValidatorService } from '../tools/validator.service';
import { AutenticacionService } from '../autenticacion.service';
import { Http } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from '../tools/errors.service';

@Injectable()
export class AutomotricesService {

  private service_url;
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/creditosAutomotrices';
  }

  public get(idCreditos : number){
    const service = this.service_url + '/' + idCreditos;
    return this.http.get(service  , this.authService.getAuthHeaders());
  }

  public save( credito : object) {
    return this.http.post(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public update( credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }


  public validate(credito : any, prestamoMaximo : number){
    let error = [];
    let data = credito.automotriz;
    let prestamo = credito.prestamo;
    let cliente = credito.cliente;
    
    if(!this.validatorService.required(data.marca)){
      error["marca"] = this.errorService.required;
    }    
    
    if(!this.validatorService.required(data.modelo)){
      error["modelo"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.anio)){
        error["anio"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.precio_compra)){
        error["precio_compra"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(data.numero_facturas)){
        error["numero_facturas"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(data.numero_endosos)){
        error["numero_endosos"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(data.ajuste_kilometraje)){
        error["ajuste_kilometraje"] = this.errorService.required;
    }    
    
    if(!this.validatorService.numeric(data.fisico_interiores)){
    error["fisico_interiores"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(data.fisico_exteriores)){
        error["fisico_exteriores"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(data.factura_agencia)){
        error["factura_agencia"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(data.juego_llaves)){
        error["juego_llaves"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(data.tenencias)){
        error["tenencias"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(data.presupuesto_reparacion)){
        error["presupuesto_reparacion"] = this.errorService.required;
    }

    if(!this.validatorService.required(prestamo.monto_prestamo)){
        error["monto_prestamo"] = this.errorService.required;
    }else if(prestamoMaximo && prestamo.monto_prestamo > prestamoMaximo){
        error["monto_prestamo"] = "El crédito solicitado debe ser menor a la oferta de préstamo total";
    }

    if(!this.validatorService.required(prestamo.tasa)){
        error["tasa"] = this.errorService.required;
    }

    if(!this.validatorService.required(prestamo.plazo_periodo)){
        error["plazo_periodo"] = this.errorService.required;
    }

    if(!this.validatorService.required(cliente.nombre)){
        error["nombre"] = this.errorService.required;
    }

    if(!this.validatorService.required(cliente.email)){
        error["email"] = this.errorService.required;
    }else if (!this.validatorService.email(cliente.email)) {
        error['email'] = this.errorService.email;
    }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/creditos/automotrices.service.ts